var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCropsSpringOnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2149 3.61725L22.664 3.88673C22.664 3.88673 22.4256 9.68614 21.5935 13.2853C20.6348 17.4317 17.7709 23.4905 17.7709 23.4905L16.6985 27.9885L18.7104 22.6174C18.7104 22.6174 21.5782 16.9767 22.8689 13.1506C24.0944 9.51764 25.2149 3.61725 25.2149 3.61725Z",
    fill: "#82CC40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2985 9.98994L26.0546 2.68557L27.5977 0.201189L29.5449 1.54306L28.3378 4.76574L27.4648 3.82625L24.2985 9.98994Z",
    fill: "#36965C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8605 30.9502L19.766 36.0524L22.9407 28.667L21.4659 34.2393L22.4054 33.3663C22.4054 33.3663 20.2848 37.5507 20.6511 39.2335C21.4959 40.1578 21.8042 41.5118 21.3349 42.7648C20.6682 44.5447 18.6849 45.4471 16.9051 44.7804C15.1252 44.1137 14.2228 42.1304 14.8895 40.3506C15.315 39.2146 16.277 38.436 17.38 38.1947C17.9942 37.632 18.3339 36.798 18.5643 36.2321C18.6064 36.1287 18.6449 36.0343 18.6807 35.9522L20.8605 30.9502Z",
    fill: "#D9E2BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3105 8.39141L26.7596 8.66088C26.7596 8.66088 26.5212 14.4603 25.6891 18.0594C24.7304 22.2058 21.8665 28.2646 21.8665 28.2646L20.7941 32.7627L22.806 27.3916C22.806 27.3916 25.6738 21.7509 26.9645 17.9247C28.19 14.2918 29.3105 8.39141 29.3105 8.39141Z",
    fill: "#82CC40"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3925 11.0087L32.6014 12.6865C32.6014 12.6865 29.9106 16.3424 28.1734 19.6025C26.1721 23.3583 22.6066 32.8292 22.6066 32.8292L22.0832 33.2456L23.5443 27.0556C23.5443 27.0556 25.7598 22.3956 27.3004 18.663C28.7632 15.119 31.3925 11.0087 31.3925 11.0087Z",
    fill: "#36965C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0915 15.897L29.8476 8.59259L31.3906 6.10822L33.3379 7.45008L32.1308 10.6728L31.2577 9.73327L28.0915 15.897Z",
    fill: "#36965C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7937 36.1293C18.0586 35.0024 17.7314 33.8427 16.9812 33.0218C16.6149 31.339 18.7355 27.1546 18.7355 27.1546L17.796 28.0276L19.2708 22.4553L16.0961 29.8408L17.1906 24.7385L15.0108 29.7405C14.9749 29.8227 14.9365 29.9171 14.8944 30.0204L14.8944 30.0204C14.6639 30.5864 14.3243 31.4203 13.71 31.9831C12.607 32.2243 11.6451 33.0029 11.2196 34.1389C10.5529 35.9188 11.4553 37.902 13.2351 38.5687C13.7911 38.777 14.3669 38.8321 14.9162 38.7553C15.4081 38.1764 16.0767 37.781 16.8072 37.6212C17.2665 37.2004 17.5723 36.628 17.7937 36.1293Z",
    fill: "#D9E2BF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8093 6.66894L27.6003 4.99115C27.6003 4.99115 24.971 9.10143 23.5083 12.6455C21.9677 16.378 19.7521 21.0381 19.7521 21.0381L18.291 27.228L18.8145 26.8116C18.8145 26.8116 22.38 17.3408 24.3813 13.585C24.8772 12.6543 25.4508 11.6914 26.0174 10.7905C26.1409 9.2179 26.1874 8.08736 26.1874 8.08736L27.9319 7.90307C28.46 7.14348 28.8093 6.66894 28.8093 6.66894Z",
    fill: "#36965C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCropsSpringOnion);
export default __webpack_public_path__ + "static/media/ic-crops-Spring-Onion.c13980619a61f6d3f216e454685b4e3e.svg";
export { ForwardRef as ReactComponent };